<template>
    <div class="contact-us full-screen">
        <div class="wrapper wrapper-full-page section content bg-image">
            <div class="container">
                <img class="mb-4 mt-5 mr-5 ml-5" src="@/assets/img/election_logo.png" alt="MUIC">
                <div v-if="itemJobDetail.length != 0 && checkVote === null">
                    <div class="mb-3 mr-5 ml-5">
                        <b-card-text>
                            <h5 class="font-en mt-2 mb-1"><strong class="font-en mr-2">Toppic :</strong>{{ itemJobDetail[0].topic }}</h5>
                            <h5 class="font-en mt-2 mb-1"><i class="fa fa-ticket mr-2" aria-hidden="true" />Your Query No : {{ itemJobDetail[0].id }}</h5>
                            <p class="font-en mb-2"><i class="fa fa-tag mr-2" aria-hidden="true" />{{ itemJobDetail[0].ticket_type_detail }}</p>
                            <hr>
                            <b-list-group v-for="(msgs, index) in itemJobDetail[0].msg_detail" :key="index">
                                <b-list-group-item 
                                    :variant="itemJobDetail[0].user === msgs.user ? 'info': ''" 
                                    class="mb-2"
                                    :class="{ 'text-right' : itemJobDetail[0].user !== msgs.user }"
                                >
                                    <p class="mb-0 f-user font-en">{{ msgs.user }}</p>
                                    <small class="font-en f-time">{{ moment(msgs.created_at).format('LLL') }}</small>
                                    <hr class="mb-1 mt-1">
                                    <p style="font-size:0.7rem;" class="mt-2 mb-0 font-en text-muted">Comment</p>
                                    <p class="mt-2 mb-1 f-comment font-en">
                                        {{ msgs.message }}
                                    </p>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card-text>
                    </div>
                    <b-card class="mr-5 ml-5 card-bor">
                        <b-card-text>
                            <label style="font-size:1.2rem;" class="text-dark font-en mt-3 mb-3"><i class="fa fa-chevron-circle-right mr-2" aria-hidden="true" />Suggestion (if any)</label>
                            <b-form-textarea
                                v-model="suggestion"
                                placeholder="Enter something..."
                                rows="3"
                                max-rows="6"
                                class="mb-4"
                            ></b-form-textarea>
                            <label style="font-size:1.2rem;" class="text-dark font-en mt-2 mb-3"><i class="fa fa-chevron-circle-right mr-2" aria-hidden="true" />Point</label>
                            <div class="row mb-3">
                                <div class="col-sm-12 col-md-6 col-xl-6 col-lg-6">
                                    <fieldset>
                                        <legend></legend>
                                        <div class="rating">
                                            <input type="radio" id="star5" name="rating" value="5" /><label class = "full" for="star5" title="5 point"></label>
                                            <input type="radio" id="star4" name="rating" value="4" /><label class = "full" for="star4" title="4 point"></label>
                                            <input type="radio" id="star3" name="rating" value="3" /><label class = "full" for="star3" title="3 point"></label>
                                            <input type="radio" id="star2" name="rating" value="2" /><label class = "full" for="star2" title="2 point"></label>
                                            <input type="radio" id="star1" name="rating" value="1" /><label class = "full" for="star1" title="1 point"></label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </b-card-text>
                    </b-card>
                    <!-- btn submit -->
                    <div class="mr-5 ml-5 mt-4 mb-4">
                        <b-button 
                            @click="addVoteTicket" 
                            style="font-size:1.2rem;" 
                            class="text-capitalize" 
                            size="sm" 
                            block variant="success"
                        ><i class="fa fa-thumbs-o-up mr-2" aria-hidden="true" />Vote / close</b-button>
                        <p class="font-en mt-0 text-danger">{{ msgTokenError === 'Please provide a satisfaction rating.' ? msgTokenError : '' }}</p>
                    </div>
                    <br>
                </div>
                <div v-else>
                    <b-alert class="mr-5 ml-5 shadow" show variant="secondary">
                        <h1 class="font-weight-bold mt-0 mb-1 text-success font-en-thank">Thank you</h1>
                        <hr class="mt-2">
                        <h3 class="mt-3 mb-1 text-dark font-en-thank">
                            for rating Your suggestion, we will continue to improve the service.
                        </h3>
                        <div class="mt-3 mb-3">
                            <b-link variant="info" size="sm" to="/icservice">
                                <h3 class="mt-0 font-en mb-0">GO TO MY MUIC<i class="fa fa-arrow-circle-right ml-3" aria-hidden="true" /></h3>
                            </b-link> 
                        </div>
                    </b-alert>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        // this.$router.push("/foundpage").catch(err => {})
        computed: {
            getTokenUrl(){
                return typeof(this.$route.query.token) === "undefined" || this.$route.query.token === "" ? this.$router.push({ name:"NotFound", params: {  ChkText: 'urlError', } }).catch(err => {}) : this.$route.query.token
            },
        },
        data(){
            return{
                suggestion:null,
                msgTokenError:'',
                itemJobDetail:[],
                checkVote:null,
            }
        },
        mounted(){
            this.callDetailJob()
        },
        methods:{
            async callDetailJob(){
                this.itemJobDetail = []
                this.msgTokenError = ''
                this.checkVote = null
                try {
                    const res = await this.$http.get(`/ticket/mail_content/?token=${this.getTokenUrl}`)
                    if(res.status === 200){
                        this.checkVote = res.data.ticketpoint
                        this.itemJobDetail.push(res.data)
                    }else{
                        throw { res }
                    }
                } catch (error) {
                    this.msgTokenError = 'errorGetToken'
                    this.checkVote = null
                    this.$router.push({ name:"NotFound", params: {  ChkText: 'Respon token error', } }).catch(err => {})
                    // this.$router.push("/foundpage").catch(err => {})
                }
            },
            async addVoteTicket(){
                this.msgTokenError = ''
                try {
                    const sendVote = new FormData()
                    sendVote.append('token', this.getTokenUrl)
                    if(document.querySelector('input[name=rating]:checked') !== null){
                        sendVote.append('ticketcomment', this.suggestion)
                        sendVote.append('ticketpoint',document.querySelector('input[name=rating]:checked').value)
                        const resVote = await this.$http.patch(`/ticket/mail_vote/`, sendVote,{
                            headers: { 'Content-Type': 'multipart/form-data' }
                        })
                        if(resVote.status === 200){
                            this.callDetailJob()
                        }else{
                            throw { resVote }
                        }
                    }else{ this.msgTokenError = 'Please provide a satisfaction rating.' }
                } catch (error) {}
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Patrick+Hand&display=swap');
    .card-bor{ 
        border-radius:5px;
        border: 2px solid #4b425f; 
    }
    .font-en{
        font-family: 'Kanit', sans-serif;
    }
    .font-en-thank{
        font-family: 'Patrick Hand', cursive;
    }
    .f-user{ font-size: 0.8rem; font-weight: 700; }
    .f-time{ font-size: 0.6rem; }
    .f-comment{
        font-size: 1rem;
    }
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    // rating vote
    /****** Style Star Rating Widget *****/
    .rating { 
        border: none;
        float: right;
    }
    .rating > input { display: none; } 
    .rating > label:before { 
        margin: 1px;
        font-size: 3em;
        // font-family: FontAwesome;
        display: inline-block;
        content: "★";
    }
    .rating > .half:before { 
        content: "\f089";
        position: absolute;
    }
    .rating > label { 
        color: #ddd; 
        float: right; 
    }
    /***** CSS Magic to Highlight Stars on Hover *****/
    .rating > input:checked ~ label, /* show gold star when clicked */
    .rating:not(:checked) > label:hover, /* hover current star */
    .rating:not(:checked) > label:hover ~ label {  color: #FFD700;  } /* hover previous stars in list */
    .rating > input:checked + label:hover, /* hover current star when changing rating */
    .rating > input:checked ~ label:hover,
    .rating > label:hover ~ input:checked ~ label, /* lighten current selection */
    .rating > input:checked ~ label:hover ~ label {  color: #FFED85;  } 
</style>